import axios from 'axios';

const prefix = '/carrierSharing';

/**
 * Retrieves default carrier sharing settings.
 * @returns {Promise<{ isDefault: boolean, isRequired: boolean, selectedServices: any[] }>} A Promise containing an object with default carrier sharing settings.
 * - `isDefault`: Boolean - Indicates whether the settings are default.
 * - `isRequired`: Boolean - Indicates whether the settings are required.
 * - `selectedServices`: Array - An array containing selected services.
 */
export const getCarrierSharingDefaults = async () => {
  const params = {};
  /**
   * @type {Promise<{ data: { isDefault: boolean, isRequired: boolean, selectedServices: any[] } }>}
   */
  const promise = axios.get(`${prefix}/default/details`, {
    ...params,
  });

  return promise.then(({ data }) => data);
};

export const getCarrierSharing = (clientExternalConnectionId) => {
  const params = {};
  return axios.get(`${prefix}/${clientExternalConnectionId}/details`, {
    ...params,
  });
};

export const applyCarrierSharingDefaults = (clientExternalConnectionIds) => {
  return axios.post(`${prefix}/apply`, clientExternalConnectionIds);
};

export const saveCarrierSharingDefaults = (saveCarrierSharingDefaultsRequest) => {
  return axios.put(`${prefix}/default`, saveCarrierSharingDefaultsRequest);
};

export const saveCarrierSharing = (saveCarrierSharingRequest) => {
  return axios.put(`${prefix}/custom`, saveCarrierSharingRequest);
};
